import { OrdStatusEnum } from '@talos/kyoko';

export const OPEN_ORDER_STATUSES = [
  OrdStatusEnum.New,
  OrdStatusEnum.PendingNew,
  OrdStatusEnum.PendingCancel,
  OrdStatusEnum.PendingReplace,
  OrdStatusEnum.PartiallyFilled,
];
